export const modalImportClients = {
	feedback: {
		verifyBaseSheet:
			", por favor verifique o modelo da planilha exemplo ou utilize-a como planilha base.",
		unidentifiedColum: "Erro nos nomes das colunas",
		emptySheet: "Essa planilha está vazia",
		emptyHeaderCell: "Falta nome nas colunas",
		sheetPoorlyFormatted:
			"Formate a planilha para fonte Calibri, tamanho 11, remova os espaços, quebras de linhas desnecessárias e negrito",
		default: "Ocorreu um erro ao importar a planilha",
		errorMessage:
			"Planilha inválida, baixe-a novamente e faça as alterações necessárias.",
		download: "Baixar",
	},
	clients: "Clientes",
	import: "Importar clientes",
	invalidClientList: "Lista de Clientes (inválida)",
	importSheet: "Importar planilha",
	downloadSheet: "Baixar planilha de exemplo",
	name: "Nome",
	cpf: "CPF",
	phone: "Telefone",
	addedClient: "cliente adicionado",
	addedClients: "clientes adicionados",
	emptyMessage: {
		title: "Nenhum cliente adicionado",
		description:
			"Adicione clientes pelo CPF ou importando uma lista de CPFs a partir da planilha de exemplo.",
	},
	add: "Adicionar clientes",
};
